import Api from './Api';

class TipoAditivoService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/tipos-aditivo', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/tipo-aditivo', data);
    }

    return this.$api.put(`/tipo-aditivo/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/tipo-aditivo/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/tipo-aditivo/${id}`);
  }
}

export default new TipoAditivoService();
